
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  inject: [`lastUpdated`],
  data () {
    return {
    };
  },
  computed: {
    postponed () {
      return this.isFixturePostponed(this.fixture);
    },
    abandoned () {
      return this.isFixtureAbandoned(this.fixture);
    },
  },
};
